<template>
  <pu-campsite-availability-link
    v-if="isCampsitePage && slug"
    v-bind="$attrs"
    :slug="slug"
  >
    <slot />
  </pu-campsite-availability-link>
  <pu-search-wizard-link
    v-else
    v-bind="$attrs"
    exclude-type="visibleMarker"
    :wizard-page="wizardPage"
  >
    <slot />
  </pu-search-wizard-link>
</template>

<script lang="ts">
import { Component, Prop, Vue } from '~/utility/pu-class-decorator'
import { isCampsiteDetailsRoute } from '../../../apps/pu-links/routeHelpers'

@Component
class SearchSummaryBarLinkMatches extends Vue {
  @Prop({ required: false })
  slug?: string

  get isCampsitePage() {
    return isCampsiteDetailsRoute(this.$route)
  }

  get wizardPage() {
    const metaType = this.$route.meta.type
    return metaType && metaType === 'maps' ? 'searcheditmaps' : 'searchedit'
  }
}

export default SearchSummaryBarLinkMatches
</script>
